module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('right-panel', {
    ref: "rightPanel",
    attrs: {
      "datas": _vm.accountInfo
    },
    on: {
      "onClose": _vm.onClose
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('translate', [_vm._v("Bind MFA")])], 1), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.mfa.nextStep),
      expression: "!mfa.nextStep"
    }],
    staticClass: "detail-wrapper"
  }, [_c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("1. You must install the MFA application on your smart device to continue.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("2. Common applications that support MFA on smart devices are ")]), _c('a', {
    staticStyle: {
      "color": "#20a0ff"
    },
    attrs: {
      "href": "https://promotion.aliyun.com/ntms/mobile.html",
      "target": "view_window"
    }
  }, [_c('translate', [_vm._v("Identity")])], 1), _vm._v(", Microsoft Authenticator，Google Authenticator.\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("3. If your account has been shared by multiple people, then when you successfully bind MFA, other unbound MFA people will not be able to log in. The solution is to let other people also install the MFA application and scan the 2D code for this page, or save the 2D code picture for others to follow the sweep. But from the security best practice, we recommend that you cancel the multiplayer account.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "detail-desc"
  }, [_c('translate', [_vm._v("4. If you can not verify for some reason, such as missing or mistakenly deleted MFA applications, you can manually unmarshal MFA binding by dialing 021-50653160.")])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mfa.nextStep && _vm.mfa.securityNumForm.mfaEwm !== ''),
      expression: "mfa.nextStep && mfa.securityNumForm.mfaEwm !== ''"
    }],
    staticClass: "detail-wrapper"
  }, [_c('el-tabs', {
    attrs: {
      "active-name": _vm.mfa.activeTab
    },
    on: {
      "tab-click": _vm.onTabClick
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "name": "first"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('translate', [_vm._v("Scan the two-dimensional code")])], 1), _vm._v(" "), _c('div', {
    staticClass: "scan-ewm"
  }, [_c('img', {
    attrs: {
      "src": _vm.mfa.securityNumForm.mfaEwm,
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Please use the MFA application on your smartphone to scan")])], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "name": "second"
    }
  }, [_c('span', {
    slot: "label"
  }, [_c('translate', [_vm._v("Manual input")])], 1), _vm._v(" "), _c('div', {
    staticClass: "hand-get"
  }, [_c('p', [_c('translate', [_vm._v("Authentication information")])], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("user name")]), _vm._v(": " + _vm._s(_vm.mfa.secret.account))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Key")]), _vm._v(": " + _vm._s(_vm.mfa.secret.secret))], 1), _vm._v(" "), _c('p', [_c('translate', [_vm._v("Please enter the above information manually in the MFA application to obtain the security code")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "securityNum"
  }, [_c('p', {
    staticClass: "tip-text"
  }, [_c('translate', [_vm._v("Please enter the two consecutive security codes you have obtained from the MFA application")]), _vm._v(":")], 1), _vm._v(" "), _c('el-form', {
    ref: "securityNumForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.mfa.securityNumForm,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.attrText.firstCode,
      "prop": "firstCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.mfa.securityNumForm.firstCode),
      callback: function($$v) {
        _vm.mfa.securityNumForm.firstCode = $$v
      },
      expression: "mfa.securityNumForm.firstCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.attrText.secondCode,
      "prop": "secondCode"
    }
  }, [_c('el-input', {
    staticClass: "input-class",
    attrs: {
      "placeholder": _vm.attrText.enterCode
    },
    model: {
      value: (_vm.mfa.securityNumForm.secondCode),
      callback: function($$v) {
        _vm.mfa.securityNumForm.secondCode = $$v
      },
      expression: "mfa.securityNumForm.secondCode"
    }
  })], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "detail-btn",
    slot: "footer"
  }, [(!_vm.mfa.nextStep) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.onNextStep()
      }
    }
  }, [_c('translate', [_vm._v("Next")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanel.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.mfa.nextStep) ? _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.submitMfaString('securityNumForm')
      }
    }
  }, [_c('translate', [_vm._v("Save")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.$refs.rightPanel.onClose()
      }
    }
  }, [_c('translate', [_vm._v("Cancel")])], 1)], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3db1d0a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/personal/model/account-open-mfa.vue
// module id = 553
// module chunks = 4 5 6